// src/client/setup-api.ts
import { client } from './client/client.gen'
import { useToast } from 'vuestic-ui'
import { useLocalStorage } from '@vueuse/core'
import { authControllerRefreshToken } from './client'
import { STORAGE_KEY_ACCESS_TOKEN, STORAGE_KEY_REFRESH_TOKEN } from './const/constants'
import { useRouter } from 'vue-router'
const router = useRouter()

export const setupApiClient = () => {
  const accessTokenStorage = useLocalStorage(STORAGE_KEY_ACCESS_TOKEN, '')
  const refreshTokenStorage = useLocalStorage(STORAGE_KEY_REFRESH_TOKEN, '')
  const { init } = useToast()

  client.setConfig({
    baseUrl: import.meta.env.VITE_APP_API_URL,
    headers: {
      Authorization: `Bearer ${accessTokenStorage.value}`,
    },
  })

  client.interceptors.request.use((config) => {
    if (accessTokenStorage.value) {
      config.headers.set('Authorization', `Bearer ${accessTokenStorage.value}`)
    }
    return config
  })

  client.interceptors.response.use(async (response) => {
    if (response.ok) {
      return response
    }

    if (response.status === 401 && refreshTokenStorage.value) {
      try {
        const refreshResponse = await authControllerRefreshToken({
          body: {
            token: refreshTokenStorage.value,
          },
        })

        if (!refreshResponse.response.ok) throw new Error('Refresh failed')

        const { accessToken, refreshToken } = refreshResponse.data as {
          refreshToken: string
          accessToken: string
        }

        accessTokenStorage.value = accessToken
        refreshTokenStorage.value = refreshToken

        const newRequest = new Request(response.url, {
          ...response,
          headers: new Headers(response.headers),
        })
        newRequest.headers.set('Authorization', `Bearer ${accessToken}`)

        return fetch(newRequest)
      } catch (error) {
        accessTokenStorage.value = ''
        refreshTokenStorage.value = ''

        init({
          message: 'Сессия истекла. Пожалуйста, войдите снова.',
          color: 'danger',
        })

        router.push('/auth/login')
        throw error
      }
    }

    return response
  })
}
